import ArrowDown from "@mui/icons-material/ArrowDownward";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditIcon from "@mui/icons-material/Edit";
import MoreIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCase } from "../../context/CaseContext";

/**
 * What can be done with an issue as a whole. Moving is offered only in the
 * directions the issue can go.
 */
export const IssueMenu = ({
  onEdit,
  onDelete,
  onMoveUp,
  onMoveDown,
}: {
  onEdit: () => void;
  onDelete: () => void;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
}) => {
  const { t } = useTranslation();
  // everything in the menu changes the case
  const { readOnly } = useCase();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const items: { label: string; icon: ReactNode; onClick?: () => void }[] = [
    {
      label: t("case.claims.issues.menu.moveUp"),
      icon: <ArrowUp fontSize="small" />,
      onClick: onMoveUp,
    },
    {
      label: t("case.claims.issues.menu.moveDown"),
      icon: <ArrowDown fontSize="small" />,
      onClick: onMoveDown,
    },
    {
      label: t("moreMenu.tip.edit"),
      icon: <EditIcon fontSize="small" />,
      onClick: onEdit,
    },
    {
      label: t("moreMenu.tip.delete"),
      icon: <DeleteIcon fontSize="small" />,
      onClick: onDelete,
    },
  ];

  return (
    <>
      <IconButton
        size="small"
        aria-label={t("case.claims.issues.menu.label")}
        aria-haspopup="menu"
        disabled={readOnly}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        <MoreIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={anchor !== null}
        onClose={() => setAnchor(null)}
      >
        {items.map(
          ({ label, icon, onClick }) =>
            onClick && (
              <MenuItem
                key={label}
                onClick={() => {
                  setAnchor(null);
                  onClick();
                }}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>{label}</ListItemText>
              </MenuItem>
            ),
        )}
      </Menu>
    </>
  );
};
